type IActionSorts = "Request" | "Post" | "Refresh" | "Close" | "Submit" | "Wrapper" | "Url" | "CloseRefresh" | "ShareUrl" | "ShareImage" | "Print" | "Sound" | "Copy";

interface IActionInfo {
    module?: string;
    controller: string;
    action: string;
    id?: string;
}
interface IActionLink {
    actionInfo: IActionInfo;
    model?: any;
}

interface IActionType {
    type: IActionSorts;
    nextAction?: IActionType;
}
interface IActionTypeUrl
    extends IActionType {
    
    url: string;
    newWindow: boolean;
}
interface IActionTypeRequest
    extends IActionType {
    
    actionLink: IActionLink;
}
interface IActionTypeCopy
    extends IActionType {
    
    text: string
}
interface IActionTypeShareUrl
    extends IActionType {
    
    title: string,
    text: string,
    url: string
}
interface IActionTypeShareImage
    extends IActionType {
    
    title: string,
    text: string,
    image: string
}
interface IActionTypeSound
    extends IActionType {

    sound: string;
}
interface IActionTypePrint
    extends IActionTypeRequest {

    path?: string;
}
interface IActionTypePost
    extends IActionTypeRequest {

    path?: string;
    setModel: boolean;
}
interface IActionTypeSubmit
    extends IActionTypeRequest {

    path?: string;
    setModel: boolean;
}

abstract class SiteAction {

    private readonly __next: SiteAction | null;

    constructor(next: SiteAction | null) {
        this.__next = next;
    }

    async execute(): Promise<boolean> {
        try {
            if ((this.__next && await this.__next.execute()) || !this.__next)
                return await this._execute();
        } catch(e) {
            // Failed, please stop :)
        }
        return false;
    }

    getNext() {
        return this.__next;
    }

    protected abstract _execute(): Promise<boolean>;

    static create(card: ISiteCard, action?: IActionType | null): SiteAction | null {
        if(!action)
            return null;

        switch (action.type) {
            case "Wrapper":
                return new SiteActionWrapper(card, action as IActionTypeRequest, SiteAction.create(card, action.nextAction));
            case "Request":
                return new SiteActionRequest(card, action as IActionTypeRequest, SiteAction.create(card, action.nextAction));
            case "Submit":
                return new SiteActionSubmit(card, action as IActionTypeRequest, SiteAction.create(card, action.nextAction));
            case "Post":
                return new SiteActionPost(card, action as IActionTypePost, SiteAction.create(card, action.nextAction));
            case "Close":
                return new SiteActionClose(card, action, SiteAction.create(card, action.nextAction));
            case "Refresh":
                return new SiteActionRefresh(card, action, SiteAction.create(card, action.nextAction));
            case "CloseRefresh":
                return new SiteActionCloseRefresh(card, action, SiteAction.create(card, action.nextAction));
            case "Url":
                return new SiteActionUrl(card, action as IActionTypeUrl, SiteAction.create(card, action.nextAction));
            case "ShareUrl":
                return new SiteActionShareUrl(card, action as IActionTypeShareUrl, SiteAction.create(card, action.nextAction));
            case "ShareImage":
                return new SiteActionShareImage(card, action as IActionTypeShareImage, SiteAction.create(card, action.nextAction));
            case "Copy":
                return new SiteActionCopy(card, action as IActionTypeCopy, SiteAction.create(card, action.nextAction));
            case "Print":
                return new SiteActionPrint(card, action as IActionTypePrint, SiteAction.create(card, action.nextAction));
            case "Sound":
                return new SiteActionSound(card, action as IActionTypeSound, SiteAction.create(card, action.nextAction));
        }

        return null;
    }

    static toLink(actionInfo: IActionInfo) {
        const arr = [actionInfo.module, actionInfo.controller, actionInfo.action, actionInfo.id];
        return arr.filter(a => a).join("/");
    }
}